import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack justify-content-between gap-5 mb-5" }
const _hoisted_2 = { class: "d-flex gap-5" }
const _hoisted_3 = { class: "card border-start border-3 border-primary" }
const _hoisted_4 = { class: "card-body px-8 py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Total registros", -1)
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-building-add fs-2 me-2 text-white" }, null, -1)
const _hoisted_8 = { class: "card mb-6" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = { class: "d-flex flex-wrap flex-stack justify-content-between gap-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1)
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-filter fs-3 me-4 text-black",
  title: "Filtrar"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "filters" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-center my-5 text-white pb-4 border-bottom" }, "Opciones de búsqueda avanzada")
], -1)
const _hoisted_15 = { class: "w-100 mb-5" }
const _hoisted_16 = { class: "d-block fw-bold mb-2" }
const _hoisted_17 = { class: "w-100 mb-5" }
const _hoisted_18 = { class: "d-block fw-bold mb-2" }
const _hoisted_19 = { class: "w-100 mb-5" }
const _hoisted_20 = { class: "d-block fw-bold mb-2" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download fs-3 text-black" }, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "card h-100 border border-secondary border-2 rounded-4 shadow-sm hover-border-primary" }
const _hoisted_25 = { class: "card-body text-center" }
const _hoisted_26 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_27 = { class: "badge badge-light-info" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png",
  alt: "Imagen no disponible"
}, null, -1)
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_31 = { class: "d-flex gap-2" }
const _hoisted_32 = { class: "badge badge-secondary" }
const _hoisted_33 = { class: "badge badge-secondary" }
const _hoisted_34 = { class: "card-footer d-flex justify-content-between px-8 py-4" }
const _hoisted_35 = { class: "d-flex gap-4" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical fs-3 px-0 text-hover-primary" }, null, -1)
const _hoisted_39 = { class: "card" }
const _hoisted_40 = { class: "card-body p-2" }
const _hoisted_41 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_42 = { class: "text-muted" }
const _hoisted_43 = { class: "fw-bolder text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_AddEditClubDrawer = _resolveComponent("AddEditClubDrawer")!
  const _component_AfiliationsDrawer = _resolveComponent("AfiliationsDrawer")!
  const _component_UploadFileModal = _resolveComponent("UploadFileModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.totalItems), 1)
          ])
        ])
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.onRegister,
        class: "w-100 w-md-auto w-lg-auto"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.filter.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.search) = $event)),
            class: "w-100 w-lg-350px",
            placeholder: `${_ctx.t('search')}...`,
            clearable: "",
            onKeypress: _withKeys(_ctx.getData, ["enter"]),
            onClear: _ctx.getData
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: _ctx.t('search'),
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.getData
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "onKeypress", "onClear"]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_popover, {
              visible: _ctx.popoverFilters,
              placement: "bottom",
              width: 300,
              trigger: "click",
              effect: "dark"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popoverFilters = !_ctx.popoverFilters)),
                  color: "#f1f4f5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" Filtro Avanzado ")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t('zone')), 1),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.filter.idzone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.idzone) = $event)),
                    clearable: "",
                    "value-on-clear": '',
                    filterable: "",
                    placeholder: _ctx.t('all')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listZone, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t('categorie')), 1),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.filter.category,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.category) = $event)),
                    multiple: "",
                    "collapse-tags": "",
                    placeholder: _ctx.t('all')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.categories, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.iddetails,
                          label: item.name,
                          value: item.iddetails,
                          disabled: _ctx.filter.category.length === 1 && _ctx.filter.category.includes(item.iddetails)
                        }, null, 8, ["label", "value", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t('ambit')), 1),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.filter.type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.type) = $event)),
                    "empty-values": [''],
                    "value-on-clear": '',
                    multiple: "",
                    placeholder: _ctx.t('all')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.types, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.iddetails,
                          label: item.name,
                          value: item.iddetails,
                          disabled: _ctx.filter.type.length === 1 && _ctx.filter.type.includes(item.iddetails)
                        }, null, 8, ["label", "value", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.popoverFilters = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: _ctx.getData
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_el_button, { color: "#f1f4f5" }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    (_ctx.listClubs.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listClubs, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-sm-3 mb-5",
                key: `lst-club-${index}`
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(item?.abrev), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass('badge badge-' + item?.status?.params)
                      }, _toDisplayString(item?.status?.name), 3)
                    ]),
                    _createVNode(_component_el_avatar, {
                      class: "mb-4",
                      size: "large",
                      src: `${_ctx.REPO}/${item?.avatar}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 2
                    }, 1032, ["src"]),
                    _createElementVNode("h4", _hoisted_29, _toDisplayString(item?.name), 1),
                    _createElementVNode("span", null, "ID: #" + _toDisplayString(item?.idinstitution), 1),
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(item?.category?.name), 1),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(item?.instype?.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_el_switch, {
                      "model-value": Number(item?.mstatus),
                      "active-value": 1,
                      "inactive-value": 0,
                      loading: _ctx.loadingId === Number(item?.idinstitution),
                      "before-change": () => _ctx.onChangeStatus(item),
                      "inline-prompt": "",
                      "active-text": "Desactivar",
                      "inactive-text": "Activar"
                    }, null, 8, ["model-value", "loading", "before-change"]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: _ctx.t('edit'),
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "bi bi-pencil fs-2 text-hover-primary cursor-pointer",
                            onClick: ($event: any) => (_ctx.onEdit(item))
                          }, null, 8, _hoisted_36)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: _ctx.t('delete'),
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "bi bi-trash fs-2 text-hover-danger cursor-pointer",
                            onClick: ($event: any) => (_ctx.onDelete(item))
                          }, null, 8, _hoisted_37)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      _createVNode(_component_el_dropdown, { trigger: "click" }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (_ctx.openUpload(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Avatar ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (_ctx.openDrawerAfiliations(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('afiliations')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: `/${_ctx.company?.alias.toLowerCase()}/institutions/${item?.idinstitution}/repman`
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('moreDetails')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])), [
            [_directive_loading, _ctx.loader]
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, [
                  _createTextVNode("Total "),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.totalItems), 1),
                  _createTextVNode(" registros")
                ]),
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.currentPage,
                  "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentPage) = $event)),
                  "page-size": _ctx.pageSize,
                  "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
                  "page-sizes": [12, 100, 200, 300, 400],
                  "pager-count": 4,
                  size: "small",
                  background: "",
                  layout: "prev, pager, next",
                  total: _ctx.totalItems,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ])
            ])
          ])
        ], 64))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "No se encontrarón registros"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getData
            }, {
              default: _withCtx(() => [
                _createTextVNode("Volver a intentar")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_AddEditClubDrawer, {
      ref: "AddEditClubDrawerRef",
      action: _ctx.actionDrawer,
      setting: _ctx.setting,
      onOnResponse: _ctx.onResponse,
      item: _ctx.rowItem
    }, null, 8, ["action", "setting", "onOnResponse", "item"]),
    _createVNode(_component_AfiliationsDrawer, { ref: "AfiliationsDrawerRef" }, null, 512),
    _createVNode(_component_UploadFileModal, {
      ref: "uploadPhotoRef",
      extens: '.png, .jpg, jpeg',
      maxFileSizeMB: 1,
      "params-upload": _ctx.paramsUpload,
      allowedMIMEs: ['image/png', 'image/jpg', 'image/jpeg'],
      onUploadResponse: _ctx.onResponse
    }, null, 8, ["extens", "params-upload", "onUploadResponse"])
  ], 64))
}